import React from 'react';

const CopyIcon = ({ className, onClick }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        onClick={onClick}
    >
        <g clipPath='url(#clip0_763_5978)'>
            <path
                d='M2.66634 10.6663C1.93301 10.6663 1.33301 10.0663 1.33301 9.33301V2.66634C1.33301 1.93301 1.93301 1.33301 2.66634 1.33301H9.33301C10.0663 1.33301 10.6663 1.93301 10.6663 2.66634M6.66634 5.33301H13.333C14.0694 5.33301 14.6663 5.92996 14.6663 6.66634V13.333C14.6663 14.0694 14.0694 14.6663 13.333 14.6663H6.66634C5.92996 14.6663 5.33301 14.0694 5.33301 13.333V6.66634C5.33301 5.92996 5.92996 5.33301 6.66634 5.33301Z'
                stroke='#D0D5DD'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_763_5978'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { CopyIcon };
